var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1079_23301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8959 19.8768C1.40556 19.9053 0.923326 19.7423 0.550889 19.4222C-0.18363 18.6833 -0.18363 17.4899 0.550889 16.7511L16.6344 0.667441C17.3984 -0.0474257 18.5972 -0.0076867 19.3121 0.756277C19.9585 1.44713 19.9962 2.50898 19.4003 3.24387L3.22196 19.4222C2.85432 19.7377 2.37982 19.9004 1.8959 19.8768Z",
    fill: "#777E90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.959 19.8769C17.462 19.8748 16.9857 19.6775 16.6329 19.3275L0.549271 3.24385C-0.131222 2.44919 -0.0387055 1.25328 0.755952 0.572721C1.4652 -0.0346571 2.51121 -0.0346571 3.2204 0.572721L19.3987 16.6563C20.1625 17.3714 20.202 18.5702 19.4869 19.334C19.4585 19.3644 19.4291 19.3938 19.3987 19.4222C19.0026 19.7667 18.4812 19.9313 17.959 19.8769Z",
    fill: "#777E90"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1079_23301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.5be9248ff67cfbbeb89238e6c4a8a906.svg";
export { ForwardRef as ReactComponent };